import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { ActivityRow } from '../live/ActivityRow';
import type { OutreachActivityEvent } from '../outreachTypes';
import { homeMessages as messages } from './homeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import liveStyles from '../live/Live.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "Latest" of the Pitch home (design outreach-v2 i1): the newest events of every campaign of the
 * artist (`home.activity`): adds, replies, listens and the people that Plug found. "Inbox" opens
 * the replies.
 */
const HomeActivityComponent: React.FC<{ events: OutreachActivityEvent[] }> = ({ events }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const rows = useMemo(() => events.map((event) => <ActivityRow key={event.id} event={event} />), [events]);
  return (
    <Panel as="section" data-testid="home-activity">
      <PanelHead
        title={intl.formatMessage(messages.latest)}
        right={
          <SMLButton size="sm" color="link" omitCap onClick={() => router.push(SMLRoutes.outreachInbox)}>
            {intl.formatMessage(messages.inbox)}
          </SMLButton>
        }
      />
      <PanelBody>
        {events.length === 0 ? (
          <p className={`${shared.small} mb-0`}>{intl.formatMessage(messages.latestEmpty)}</p>
        ) : (
          <ul className={`${liveStyles.timeline} p-0 m-0`}>{rows}</ul>
        )}
      </PanelBody>
    </Panel>
  );
};

export const HomeActivity = TypedMemo(HomeActivityComponent);
